export default {
  SUCCESS: 200, // 成功
  UNAUTHORIZED: 401 // 过期
}
